import { Button, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import { ILikvidacePrikaz, IVypisJina, PrikazLikvidacePut, PrikazVypisJinyPut } from 'services/dokumenty/prikazy';

import { EPodTypDokumentu } from 'enums/dokumentyEnums';

export const JinaOsobaPodpisEditBtn = (
    zadostID: number,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setRefetch: React.Dispatch<React.SetStateAction<boolean>>
) => {
    const { confirm } = Modal;

    const { dokumenty } = useContext(Context);
    const [allowEdit, setAllowEdit] = useState<boolean>(false);

    const type =
        dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.EMISELIKV
            ? 'likvidace'
            : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.EMISEFUZE
              ? 'fuze'
              : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.ZMENFUZE
                ? 'prevzeti'
                : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.EMISELIST
                  ? 'list'
                  : dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.ZMENJINA
                    ? 'jina'
                    : '';

    useEffect(() => {
        if (!allowEdit) return;

        let dataToSend = {
            ...dokumenty?.jinaOsobaZadostData,
            souhlas: false
        };
        const AllowEditApiCall = () => {
            setLoading(true);
            (dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.VYPIS
                ? PrikazVypisJinyPut(zadostID, dataToSend as IVypisJina)
                : PrikazLikvidacePut(zadostID, dataToSend as ILikvidacePrikaz, type)
            )
                .then(() => {
                    setRefetch(pv => !pv);
                })
                .finally(() => setLoading(false));
        };

        AllowEditApiCall();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowEdit]);

    const allowFunc = (callback?: () => void) =>
        confirm({
            title: <TranslateText>DOKUMENTY_OSOBY_ZMENIT_JINA</TranslateText>,
            cancelText: <TranslateText>NE</TranslateText>,
            okText: <TranslateText>ANO</TranslateText>,
            onOk() {
                setAllowEdit(true);
                callback?.();
            }
        });

    const renderEditBtn = () => (
        <Button
            style={{
                top: '30%',
                right: 10,
                position: 'fixed',
                zIndex: 999
            }}
            type="primary"
            onClick={() => allowFunc()}
        >
            <TranslateText>POVOLIT_EDITACI</TranslateText>
        </Button>
    );

    return [renderEditBtn, setAllowEdit, type, allowFunc] as const;
};
